import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent } from "../Utility/Utility";
import { decryptURLParam, encryptURLParam } from "../../Common/Axios/encrypt";

const SortBy = ({ products, onSortChange, onClearSort }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedSort, setSelectedSort] = useState("");
  const translation = getTranslationData();
  // to get data from redux store
  const addSpecialData = useSelector(
    (state) => state.addSpecialReducer.getData
  );
  // get initial sort value from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sortBy = params.get("sortBy") || "";
    const sortOrderParam = sortBy
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? sortBy
        : decryptURLParam(sortBy)
      : null;
    setSelectedSort(sortOrderParam || "");
  }, [location.search]);

  // notify parent when selectedSort changes
  useEffect(() => {
    onSortChange && onSortChange(selectedSort);
  }, [selectedSort]);

  const handleSortChange = (value) => {
    setSelectedSort(value);
    trackEvent("sorting_applied", {
      sorting: {
        sort_by: value === "name-asc" ? "Alphabetically" : "Discount",
        sort_direction: value === "Discount" ? "Discount" : "asc",
      },
    });
    const params = new URLSearchParams(location.search);
    params.delete("trending");
    params.delete("specialId");
    const finalVal =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? value
        : encryptURLParam(value);
    if (finalVal) {
      params.set("sortBy", finalVal);
    } else {
      params.delete("sortBy");
    }
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const clearFilter = (e) => {
    e.preventDefault();
    setSelectedSort("");
    const params = new URLSearchParams(location.search);
    params.delete("sortBy");
    params.delete("trending");
    params.delete("specialId");
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    onClearSort && onClearSort();
    onSortChange && onSortChange("");
  };

  // find Top Picks section
  const topPicksSection = Array.isArray(addSpecialData)
    ? addSpecialData.find((item) => item?.visibleBy === "TOP_PICKS")
    : null;

  const handleTopPicksClick = () => {
    if (!topPicksSection) return;

    const params = new URLSearchParams();

    const finalSort =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? "TopPicks"
        : encryptURLParam("TopPicks");

    const finalTrending =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? "true"
        : encryptURLParam("true");

    const finalSpecialId =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? topPicksSection?.id?.toString()
        : encryptURLParam(topPicksSection?.id?.toString());

    params.set("sortBy", finalSort);
    params.set("trending", finalTrending);
    params.set("specialId", finalSpecialId);

    navigate(`/productlist?${params.toString()}`, {
      replace: true,
      state: {
        isTrending: true,
        productData: topPicksSection?.products,
        name: topPicksSection?.sectionName,
      },
    });
  };

  return (
    <div className="filterdrpbtn">
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="fill">{translation?.sortBy}</h3>
        <div className="clearAll_position">
          <i
            className="fa-solid fa-circle-xmark cursorPointer"
            onClick={clearFilter}
          ></i>
          <Link className="text-right" onClick={clearFilter}>
            {translation?.clearSort}
          </Link>
        </div>
      </div>

      <div className="sort-type">
        <label className="customcheckbox">
          <input
            id="name-asc"
            type="radio"
            name="shortBy"
            checked={selectedSort === "name-asc"}
            onChange={() =>
              handleSortChange(selectedSort === "name-asc" ? "" : "name-asc")
            }
          />
          <label className="sort-label" htmlFor="name-asc">
            {translation?.alphabet}
          </label>
          <span className="checkmark"></span>
        </label>
        {topPicksSection && (
          <label className="customcheckbox">
            <input
              id="TopPicks"
              type="radio"
              name="shortBy"
              checked={selectedSort === "TopPicks"}
              onChange={handleTopPicksClick}
            />
            <label className="sort-label">
              {translation.sortBy_top_pick || "Top Picks"}
            </label>
            <span className="checkmark"></span>
          </label>
        )}
        <label className="customcheckbox">
          <input
            id="Discount"
            type="radio"
            name="shortBy"
            checked={selectedSort === "Discount"}
            onChange={() => handleSortChange("Discount")}
          />
          <label className="sort-label" htmlFor="Discount">
            {translation.sortBy_discount || "Discount"}
          </label>
          <span className="checkmark"></span>
        </label>
      </div>
    </div>
  );
};

export default SortBy;
